<!-- IF WE ADD NEW ICONS IN HERE, PLEASE MAKE SURE TO UPDATE THE STYLEGUIDE -->
@if (alerts.polledAlerts$! | async; as alerts) {
  <div id="accordion" class="card-expansion no-print">
    @for (alert of alerts; track alert; let i = $index) {
      <div class="alert alert-danger has-icon card card-expansion-item">
        <div class="alert-icon">
            <i class="fa" [ngClass]="!postTypes.includes(alert.PostType)?'fa-info-circle':{
               'fas fa-bolt': alert.PostType.includes('Adverse') || alert.PostType.includes('Weather'),
               'fa-fingerprint': alert.PostType.includes('Crime'),
               'fa-exclamation-triangle': alert.PostType.includes('Emergency'),
               'fa-cogs': alert.PostType.includes('Server'),
               'fas fa-clock': alert.PostType.includes('Timely'),
               'fa-info-circle': alert.PostType.includes('Info')
               }"></i>
        </div>
        <button class="btn d-flex justify-content-between w-100 collapsed alert-btn"
          data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseAlert' + i" aria-expanded="false" [attr.aria-controls]="'collapseAlert' + i">
          <strong>{{alert.Title}}</strong>
          <span class="collapse-indicator">
            <i class="fa fa-fw fa-chevron-down"></i>
          </span>
        </button>
        <div [id]="'collapseAlert' + i" class="collapse"
          [attr.aria-labelledby]="'headingAlert' + i" data-bs-parent="#accordion">
          @if (!!alert.Html) {
            <div [id]="'headingAlert' + i" class="card card-alert-html" [innerHTML]="alert.Html"></div>
          }
        </div>
      </div>
    }
  </div>
}
